import { TeamLogoInline } from "./TeamLogoInline.tsx";
import {
	translateTeamRegion,
	translateTeamName,
	translateTeamShortName,
} from "../util/teamNames.ts";

type Team = {
	seasonAttrs: {
		imgURL?: string;
		imgURLSmall?: string;
		abbrev: string;
		name: string;
		region: string;
	};
	tid: number;
};

const TeamLogoAndName = ({
	t,
	url,
	noAbbrev,
	noLogo,
}: {
	t: Team;
	url: string;
	noAbbrev?: boolean;
	noLogo?: boolean;
}) => {
	return (
		<div className="d-flex align-items-center gap-1">
			{!noLogo ? (
				<TeamLogoInline
					imgURL={t.seasonAttrs.imgURL}
					imgURLSmall={t.seasonAttrs.imgURLSmall}
				/>
			) : null}
			<div>
				<a href={url}>
					<span className={noAbbrev ? "" : "d-none d-sm-inline"}>
						{translateTeamRegion(t.seasonAttrs.region)} {translateTeamName(t.seasonAttrs.name)}
					</span>
					<span className={noAbbrev ? "d-none" : "d-sm-none"}>
						{translateTeamShortName(t.seasonAttrs)}
					</span>
				</a>
			</div>
		</div>
	);
};

export const wrappedTeamLogoAndName = (
	t: Team,
	url: string,
	options?: {
		noAbbrev?: boolean;
		noLogo?: boolean;
	},
) => ({
	value: <TeamLogoAndName t={t} url={url} {...options} />,
	searchValue: `${t.seasonAttrs.region} ${t.seasonAttrs.name} ${t.seasonAttrs.abbrev}`,
	sortValue: `${t.seasonAttrs.region} ${t.seasonAttrs.name} ${t.seasonAttrs.abbrev}`,
});

export default TeamLogoAndName;
